<template>
  <div class="bp-tag">
    <div class="tag" :class="[tagColor, { chip }]">
      <bp-icon v-if="icon" size="14" :icon="icon" />
      <div class="text">{{ text }}</div>
      <bp-icon v-if="trailingIcon" size="14" :icon="trailingIcon" />
      <button v-if="chip" @click.stop="$emit('remove')" :disabled="disabled">
        <i class="fa-solid fa-xmark" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "neutral",
      validation: v =>
        [
          "neutral",
          "primary",
          "information",
          "alert",
          "negative",
          "orange",
          "yellow",
          "chartreuse",
          "green",
          "spring",
          "aqua",
          "azure",
          "blue",
          "violet",
          "fuchsia",
          "rose"
        ].includes(v)
    },
    chip: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String
    },
    trailingIcon: {
      type: String
    }
  },
  computed: {
    tagColor() {
      return `bp-tag-${this.color}`;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/tags";

.bp-tag {
  .chip {
    background: $neutral-024;
  }
  .tag {
    display: flex;
    font-weight: 500;
    width: fit-content;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    padding: 2px;
    .text {
      font-size: 12px;
      margin: 0px 4px;
      @media screen and (max-width: 767px) {
        margin: 0px 8px;
      }
    }
    button {
      margin: 2px;
      width: 14px;
      height: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: none;
      color: $neutral-300;
      background: transparent;
      border: none;
      border-radius: 50%;
      border: 1.2px solid $neutral-300;
      transition: 0.2s all;
      i {
        color: $neutral-300;
        font-size: 8px;
      }
      &:disabled {
        pointer-events: none;
      }
      &:hover {
        background: $neutral-200;
        i {
          color: white;
        }
      }
    }
  }
}
</style>
